import { render, staticRenderFns } from "./CustomerTabsNotes.vue?vue&type=template&id=54fba5f6&scoped=true&"
import script from "./CustomerTabsNotes.vue?vue&type=script&lang=js&"
export * from "./CustomerTabsNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54fba5f6",
  null
  
)

export default component.exports